module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "INTRODUCTION"
    }
  }, [_vm._v("INTRODUCTION.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The book to which these lines form an introduction is a peculiar\none in many respects. It is a story, but it is a true story, and\nwritten years ago with little idea that it would ever come into this\nform. The writer has been induced, only recently, by the advice\nof friends and by his own feeling that such a production would be\nappreciated, to present what, at the time it was being made up,\nwas merely a means of occupying a mind which had to contemplate,\nbesides, only the horrors of a situation from which death\nwould have been, and was to thousands, a happy relief.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The original diary in which these writings were made from day\nto day was destroyed by fire some years after the war, but its contents\nhad been printed in a series of letters to the Jackson, (Mich.)\n"), _c('cite', [_vm._v("Citizen")]), _vm._v(", and to the editor and publisher of that journal thanks are\nnow extended for the privilege of using his files for the preparation\nof this work. There has been little change in the entries in\nthe diary, before presenting them here. In such cases the words\nwhich suggest themselves at the time are best—they cannot be improved\nupon by substitution at a later day.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("This book is essentially different from any other that has been\npublished concerning the “late war” or any of its incidents. Those\nwho have had any such experience as the author will see its truthfulness\nat once, and to all other readers it is commended as a statement\nof actual things by one who experienced them to the fullest.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The annexed list of the Andersonville dead is from the rebel\nofficial records, is authentic, and will be found valuable in many\npension cases and otherwise.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre illowe10 figure",
    attrs: {
      "id": "i_008"
    }
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "Good Luck charm",
      "id": "id-4122828965160073441",
      "src": "Images/img0002.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0